export function sanitizeHtml(input: string): string {
  if (!input) return "";

  let html = input;

  // Remove script and style tags completely
  html = html.replace(/<\/(?:script|style)>/gi, "");
  html = html.replace(/<(?:script|style)[^>]*>[\s\S]*?<\/(?:script|style)>/gi, "");

  // Remove head-level tags that should never appear in body (meta, link, title, head, object, embed, form, etc.)
  html = html.replace(/<\/?(?:meta|link|object|embed|form|input|button|iframe|title|head)[^>]*>/gi, (match) => {
    // Allow only YouTube embed iframes; everything else removed
    if (/^<iframe/i.test(match)) {
      const srcMatch = match.match(/src\s*=\s*(["'])(.*?)\1/i);
      const src = srcMatch?.[2] ?? "";
      if (/^https:\/\/www\.youtube\.com\/embed\/[a-zA-Z0-9_-]{11}(\?.*)?$/.test(src)) {
        // Strip all attributes except safe ones
        const allowAttrs = [
          'src',
          'allow',
          'allowfullscreen',
          'frameborder',
          'referrerpolicy',
          'title',
        ];
        const attrs: string[] = [];
        const attrRegex = /(\w[\w-]*)\s*=\s*(["'])[\s\S]*?\2/gi;
        let m: RegExpExecArray | null;
        while ((m = attrRegex.exec(match))) {
          const name = m[1].toLowerCase();
          if (allowAttrs.includes(name)) {
            attrs.push(m[0]);
          }
        }
        const safe = `<iframe ${attrs.join(' ')}></iframe>`;
        return safe;
      }
    }
    return "";
  });

  // Additionally remove any entire <head>...</head> blocks if present
  html = html.replace(/<head[^>]*>[\s\S]*?<\/head>/gi, "");

  // Remove inline event handlers like onclick, onerror, etc.
  html = html.replace(/\son[a-z]+\s*=\s*("[\s\S]*?"|'[\s\S]*?'|[^\s>]+)/gi, "");

  // Neutralize javascript: and data: URLs in href/src
  html = html.replace(/\s(href|src)\s*=\s*(["']?)\s*(javascript:|data:)[^"'>\s]*/gi, ' $1="#"');

  // Keep only formatting declarations emitted by the editor.
  html = html.replace(/\sstyle\s*=\s*("[\s\S]*?"|'[\s\S]*?'|[^\s>]+)/gi, (_match, quoteValue: string) => {
    const declarations = quoteValue.replace(/^['"]|['"]$/g, "").split(";");
    const safe = declarations.filter((declaration) => {
      const property = declaration.split(":")[0]?.trim().toLowerCase();
      return ["color", "background-color", "font-size", "font-family", "text-align"].includes(property);
    }).map((declaration) => declaration.trim()).filter((declaration) => {
      const value = declaration.split(":").slice(1).join(":").trim();
      return value && !/[<>;]/.test(value) && !/expression|url\s*\(/i.test(value);
    });
    return safe.length ? ` style="${safe.join("; ")}"` : "";
  });

  // Remove SVG scriptable elements
  html = html.replace(/<\/?(?:svg|animate|set|foreignObject)[^>]*>/gi, "");

  return html;
}
